import React from 'react'
import Reviews from '../../../components/Front/Reviews/Reviews'
import OnlinePkBanner from '../../../assets/images/front/online-pk-5-banner.png'
import OnlinePkBannerMobile from '../../../assets/images/front/online-pk-5-banner-mobile.png'
import OnlinePk5BannerGraphics from '../../../assets/images/front/svg/online-pn-all-banner-graphics.svg'
import Image190 from '../../../assets/images/front/190.png'
import ImageHand from '../../../assets/images/front/ruka.png'
import SkolaBannerSecondary from '../../../assets/images/front/online-pn-all-banner-secondary.png'
import ArrowRightBlue from '../../../assets/images/front/svg/arrow-right-blue.svg'
import OnlinePnAllButton from '../../../assets/images/front/svg/online-pn-all-button.svg'
import { routesURLs } from '../../../Routes'
import { useHistory } from 'react-router-dom'
import { useQuery } from 'react-query'
import { getOnlineMockExamCourses } from '../../../moduls/online-mock-exam-courses'
import { OnlineMockExamCourseType } from '../../../services/types'

const Pn9Online: React.FC = () => {
  const history = useHistory()
  const { data: courses } = useQuery('onlineMockExamCourses', getOnlineMockExamCourses)
  const course = courses?.find((course: OnlineMockExamCourseType) => course.name === 'NANEČISTO 9. TŘÍDA')

  return (
    <>
      <div className="container relative mx-auto mt-[52px] lg:mt-[84px]">
        <img
          src={OnlinePkBanner}
          alt=""
          className="w-full min-h-[350px] h-auto hidden md:block object-cover rounded-b-3xl"
        />
        <img
          src={OnlinePkBannerMobile}
          alt=""
          className="w-full min-h-[350px] h-auto md:hidden object-cover"
        />
        <div className="absolute left-[50%] translate-x-[-50%] md:translate-x-0 md:left-8 top-4 w-[calc(100%-16px)] md:w-full px-4">
          <img
            src={OnlinePk5BannerGraphics}
            alt=""
            className="w-full max-w-[585px] h-auto object-cover"
          />
        </div>
        <div className="absolute right-[-50%] translate-x-[-50%] md:translate-x-0 bottom-10 md:right-20 md:bottom-20 flex md:block items-center justify-center w-full md:w-auto">
          <span
              onClick={() => history.push(
                  course
                      ? `${routesURLs.onlineMockExamCourses}/${course.id}`
                      : routesURLs.onlineMockExamCourses
              )}
            className="inline-block text-2xl md:text-5xl pt-3 text-white bg-[#A8CD00] hover:bg-[#8FB200] tracking-wide leading-tight px-10 py-2 rounded-xl transition-colors duration-200 relative"
          >
            přihlásit se
            <img
              src={OnlinePnAllButton}
              alt=""
              className="absolute top-[30%] translate-y-[-50%] -right-10 w-[100px] hidden md:block"
            />
            <img src={Image190} alt="" className="absolute w-[60px] -top-10 -right-8 md:hidden" />
            <img
              src={ImageHand}
              alt=""
              className="absolute w-[60px] -bottom-9 left-[50%] translate-x-[-50%] md:hidden"
            />
          </span>
        </div>
      </div>
      <div className="px-4">
        <div className="container mx-auto py-[30px] md:pt-[60px]">
          <div className="grid grid-cols-12 gap-4 lg:gap-8">
            <div className="col-span-12 lg:col-span-6">
              <img
                src={SkolaBannerSecondary}
                alt=""
                className="w-full h-auto object-cover rounded-3xl"
              />
            </div>
            <div className="col-span-12 lg:col-span-6">
              <h2 className="text-[25px] text-[#0183BA] mb-4 md:-mt-2">Jak to funguje?</h2>
              <div className="grid grid-cols-12 gap-4 leading-tight">
                <div className="col-span-12 flex items-start">
                  <div className="shrink-0 w-10 h-10 bg-[#A8CD00] text-white flex items-center justify-center text-4xl me-4">
                    1.
                  </div>
                  <div className="font-myriad">
                    <strong>Vyberte si test a dokončete nákup.</strong>
                    <br />
                    <span>Po zaplacení se vám v profilu automaticky zpřístupní:</span>
                    <ul className="ms-8 is-pure-list">
                      <li className="flex items-center">
                        <img src={ArrowRightBlue} alt="" className="me-1" />
                        zadání testu,
                      </li>
                      <li className="flex items-center">
                        <img src={ArrowRightBlue} alt="" className="me-1" />
                        záznamové archy,
                      </li>
                      <li className="flex items-center">
                        <img src={ArrowRightBlue} alt="" className="me-1" />
                        video s podrobnými pokyny.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-span-12 flex items-start">
                  <div className="shrink-0 w-10 h-10 bg-[#A8CD00] text-white flex items-center justify-center text-4xl me-4">
                    2.
                  </div>
                  <div className="font-myriad">
                    <strong>Vyplňte test kdykoliv z pohodlí domova.</strong>
                    <br />
                    <span>
                      Máte přesně stanovený časový limit – stejně jako u ostrých přijímaček.
                    </span>
                  </div>
                </div>
                <div className="col-span-12 flex items-start">
                  <div className="shrink-0 w-10 h-10 bg-[#A8CD00] text-white flex items-center justify-center text-4xl me-4">
                    3.
                  </div>
                  <div className="font-myriad">
                    <strong>Nahrajte své vyplněné záznamové archy.</strong>
                    <br />
                    <span>Stačí je vyfotit a odevzdat ve vašem profilu.</span>
                  </div>
                </div>
                <div className="col-span-12 flex items-start">
                  <div className="shrink-0 w-10 h-10 bg-[#A8CD00] text-white flex items-center justify-center text-4xl me-4">
                    4.
                  </div>
                  <div className="font-myriad">
                    <strong>Získejte opravený test a zpětnou vazbu.</strong>
                    <br />
                    <span>Jakmile test opravíme, dostanete notifikaci. V profilu najdete:</span>
                    <ul className="ms-8 is-pure-list">
                      <li className="flex items-center">
                        <img src={ArrowRightBlue} alt="" className="me-1" />
                        výsledek vašeho testu
                      </li>
                      <li className="flex items-center">
                        <img src={ArrowRightBlue} alt="" className="me-1" />
                        kompletní videorozbor (postupy a řešení)
                      </li>
                      <li className="flex items-center">
                        <img src={ArrowRightBlue} alt="" className="me-1" />
                        porovnání s ostatními studenty
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="-mb-12">
        <div className="HP">
          <Reviews />
        </div>
      </div>
    </>
  )
}

export default Pn9Online
